import { createContext } from 'react'
const initial = {
  products: [],
  services: [],
  templates: [],
}

export const AppContext = createContext(initial)
